import CaptureNationalFront from "@/modules/national/pages/CaptureNationalFront.vue";
import CaptureNationalBack from "@/modules/national/pages/CaptureNationalBack.vue";
import ChooseNationalId from "@/modules/national/pages/ChooseNationalId.vue";

export default [
  {
    path: "/document/national/front",
    name: "captureNationalFront",
    component: CaptureNationalFront,
  },
  {
    path: "/document/national/back",
    name: "captureNationalBack",
    component: CaptureNationalBack,
  },
  {
    path: "/document/national/jm/decide",
    name: "chooseNationalId",
    component: ChooseNationalId,
  },
];
